/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
// module icons
export enum ModuleIcons {
    HOME = 'pi pi-home',
    SCHEDULING = 'g-chart-data',
    PLANNING = 'pi g-chart-data',
    DATASOLUTIONS = 'pi pi-database',
    TOOLS = 'pi pi-wrench'
}

export enum DocumentIcons {
    REPORT = 'pi pi-file-o',
    DASHBOARD = 'pi pi-objects-column'
}
